/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, UNPLACEHOLDER } from '@dm/core';
import { type SelectOption } from '@dm/core/types';

import { AlarmOrEventLevelE } from './alarms-and-events.const';

@Injectable({ providedIn: 'root' })
export class AlarmsAndEventsStrService {
    constructor(
        private i18n: I18nService,
    ) {}

    labelText = {
        title: this.i18n.get('monitor.alarmAndLog_term_title_label'),
        alarmsTab: this.i18n.get('monitor.alarm_term_realTime_label'),
        eventsTab: this.i18n.get('monitor.alarm_term_type_event_label'),
        level: this.i18n.get('common.alarmLevel_label'),
        description: this.i18n.get('common.description_column'),
        objectType: this.i18n.get('monitor.alarm_term_objectType_col'),
        recoveredAt: this.i18n.get('monitor.alarm_term_rescoveryTime_col'),
        occurredAt: this.i18n.get('monitor.alarm_term_happenTime_col'),
        ID: 'ID',
        no: this.i18n.get('monitor.dashboard_term_SequenceNumber_lab'),
        eventType: this.i18n.get('common.type_column'),
        alarmStatus: this.i18n.get('common.status_label'),
    };

    levelIcon = {
        [AlarmOrEventLevelE.INFO]: '#icon-status-info',       // 提示
        [AlarmOrEventLevelE.WARNING]: '#app-icon-alarms-minor-new',      // 警告
        [AlarmOrEventLevelE.MAJOR]: '#icon-alarms-major',         // 重要
        [AlarmOrEventLevelE.CRITICAL]: '#icon-alarms-critical',    // 紧急
    };

    levelStatus = {
        [AlarmOrEventLevelE.INFO]: 'info',       // 提示
        [AlarmOrEventLevelE.WARNING]: 'minor',      // 警告
        [AlarmOrEventLevelE.MAJOR]: 'major',      // 重要
        [AlarmOrEventLevelE.CRITICAL]: 'critical',    // 紧急
    };

    levelText = {
        [AlarmOrEventLevelE.INFO]: this.i18n.get('common.EnumDefine_EVENT_LEVEL_E_INFO'),
        [AlarmOrEventLevelE.WARNING]: this.i18n.get('common.EnumDefine_EVENT_LEVEL_E_WARNING'),
        [AlarmOrEventLevelE.MINOR]: this.i18n.get('common.EnumDefine_EVENT_LEVEL_E_MINOR'),
        [AlarmOrEventLevelE.MAJOR]: this.i18n.get('common.EnumDefine_EVENT_LEVEL_E_MAJOR'),
        [AlarmOrEventLevelE.CRITICAL]: this.i18n.get('common.EnumDefine_EVENT_LEVEL_E_CRITICAL'),
    };

    alarmStatusText = {
        '-1': UNPLACEHOLDER,
        1: this.i18n.get('common.EnumDefine_ALARM_STATUS_E_UNRECOVERED'),
        2: this.i18n.get('common.EnumDefine_ALARM_STATUS_E_CLEARED'),
        4: this.i18n.get('common.EnumDefine_ALARM_STATUS_E_RECOVERED'),
    };

    typeText = {
        0: this.i18n.get('monitor.alarmAndLog_term_event_label'),
        1: this.i18n.get('monitor.alarm_term_type_currentAlarm_label'),
        2: this.i18n.get('monitor.alarm_term_type_recovered_label'),
        3: this.i18n.get('monitor.alarm_term_type_userlog_label'),
        4: this.i18n.get('monitor.alarm_term_type_systemlog_label'),
        8: this.i18n.get('monitor.alarm_term_type_currentAlarm_label'),
        // 安全日志
        10: this.i18n.get('monitor.alarm_term_type_security_label'),

    };
    anomalyIconTip = this.i18n.get('monitor.recentException_viewExceptionInfo_tip');
    duration = this.i18n.get('system.exportData_task_duration_lab', true);
    size = this.i18n.get('settings.upgrade_task_size_lab', true);
    aboutTime = (time: number): string => this.i18n.get('system.exportData_task_time_value', [time]);
    aboutSize = (size: string): string => this.i18n.get('system.exportData_task_size_value', [size]);
    commonTip = '\n' + this.duration + this.aboutTime(10)
        + '\n'
        + this.size + this.aboutSize('10');
    currentAlarmLab = this.i18n.get('monitor.alarm_term_type_currentAlarm_label');
    AllValue = this.i18n.get('common.all_value');
    clearAlarmTitle = this.i18n.get('monitor.alarm_term_clearalarm_title');
    clearAlarmTip = this.i18n.get('monitor.clean_task_info_result_msg');
    clearSuccess = this.i18n.get('monitor.term_batch_clear_execute_successed_result');
    clearBtnText = this.i18n.get('common.clear_button');
    sendSimulateAlarmTip = this.i18n.get('monitor.monitor_alarmAndEvent_desc_label');
    sendButtonText = this.i18n.get('monitor.setAlarm_term_sendAnalogAlarm_btn');
    sendSimulateAlarm = this.i18n.get('rest.sendAnalogAlarm_msg');
    sendSimulateAlarmSuccess = this.i18n.get('monitor.setAlarm_task_testAlarm_information_startAlarm_tip');
    exportAllTip = this.i18n.get('monitor.alarm_term_exportAll_tips') + this.commonTip;
    exportSelectedTip = this.i18n.get('monitor.alarm_term_auditLog_exportSelected_button');
    setAlarmBuzzeTitle = this.i18n.get('common.setAlarmBuzzer_task_title_label');
    recentAlarm = this.i18n.get('monitor.recentAlarm_latast_lab');
    setAlarmBuzzerInstruction = this.i18n.get('common.setAlarmBuzzer_instruction_label');
    alarmLevel = this.i18n.get('common.Main_Label_AlarmLevel');
    modifySeverityTipStart = this.i18n.get('monitor.monitor_alarmAndEvent_modifySeverity_desc1');
    modifySeverityButtonText = this.i18n.get('monitor.monitor_alarmAndEvent_modifySeverity_desc2');
    modifySeverityTipEnd = this.i18n.get('monitor.monitor_alarmAndEvent_modifySeverity_desc3');
    sendSimulateTipStart = this.i18n.get('monitor.monitor_alarmAndEvent_desc1');
    sendSimulateTipEnd = this.i18n.get('monitor.monitor_alarmAndEvent_desc2');
    needHelp = this.i18n.get('monitor.alarm_term_smartFix_suggest_existProblem_btn');
    contactHelp = this.i18n.get('monitor.alarm_term_smartFix_suggest_existProblem_desc');
    basicInfoLab = this.i18n.get('common.basicInfo_title');
    suggestionLab = this.i18n.get('monitor.alarm_term_rescoverySuggestion_col');
    refresh = this.i18n.get('system.hardware_term_refresh_button');

    detailsLabelText = {
        alarmHeader: this.i18n.get('monitor.alarm_term_alarmDetail_lab'),
        eventHeafer: this.i18n.get('monitor.alarm_term_eventDetail_lab'),
        level: this.labelText.level,
        deviceName: this.i18n.get('common.deviceName_label'),
        deviceLocation: this.i18n.get('common.device_location_label'),
        ID: 'ID',
        occurredAt: this.labelText.occurredAt,
        recoveredAt: this.labelText.recoveredAt,
        type: this.labelText.eventType,
        alarmStatus: this.labelText.alarmStatus,
        sequenceNo: this.labelText.no,
        suggestion: this.i18n.get('monitor.alarm_term_rescoverySuggestion_col'),
        closeBtn: this.i18n.get('common.close_button'),
        cancelBtn: this.i18n.get('common.cancel_button'),
        saveBtn: this.i18n.get('common.confirm_button'),
        description: this.i18n.get('common.description_column'),
        collectBtnLabel: this.i18n.get('monitor.alarmAndLog_simplifiedMode_infoCollect_btn'),
    };

    // 告警级别选项
    alarmLevelOpt = {
        3: this.levelText[3],
        5: this.levelText[5],
        6: this.levelText[6],
    };

    // 事件级别选项
    eventLevelOpt = {
        2: this.levelText[2],
        3: this.levelText[3],
        5: this.levelText[5],
        6: this.levelText[6],
    };

    // 事件对象类型选项-控件初始化时动态生成
    objectTypeOpt = {};

    // 告警清除状态选项
    alarmStatusOpt = {
        1: this.alarmStatusText[1],
        2: this.alarmStatusText[2],
        4: this.alarmStatusText[4],
    };

    // 告警清除状态选项
    alarmStatusOption: SelectOption[] = [
        {
            value: '1',
            label: this.alarmStatusText[1],
        },
        {
            value: '4',
            label: this.alarmStatusText[4],
        },
        {
            value: '2',
            label: this.alarmStatusText[2],
        },
    ];

    // 事件类型选项
    eventTypeOpt = {
        8: this.typeText[8],
        2: this.typeText[2],
        3: this.typeText[3],
        4: this.typeText[4],
        10: this.typeText[10],
    };

    successStr(...args): string {
        return this.i18n.get('common.rest_success_label', args);
    }

    // 删除告警tips
    clearAlarmTips(name): string {
        return this.i18n.get('rest.clearAlarm_msg', [name]);
    }
}
